<div *ngIf="message" [ngClass]="{ 'alert alert-fixed alert-dismissible': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    {{message.text}}
</div>